module.exports = "/_next/static/images/paul-09fb2b95db19544bb47706138f81be19.jpg";